export const CONFIGCAT_KEYS = {
	MAINTENANCE: 'maintenance',
	AVATAR_CHANGE: 'avatarChange',
	PROFILE_EDIT_MODAL_SETTINGS: 'profileEditModalSettings',
	DOPING_TECH_COMPONENTS_CACHE_STR: 'dopingTechComponentsCacheStr',
	IS_OPEN_BACKGROUND_MODE: 'isOpenBackgroundMode',
	IS_ACTIVE_SOLVER_MOBILE_DIRECTION: 'isActiveSolverMobileDirection',
	IS_ACTIVE_SOLVER_WEB_DIRECTION: 'isActiveSolverWebDirection',
	IS_ACTIVE_SOLVER_ANSWERED_QUESTIONS_MOBILE_DIRECTION: 'isActiveSolverAnsweredQuestionsMobileDirection',
	MOBILE_DIRECTION_QR_CODE_URL: 'mobileDirectionQrCodeUrl',
	IS_ACTIVE_SOLVER_VP8_CODEC: 'isActiveSolverVP8Codec',
	IS_ACTIVE_SOLVER_FFMPEG: 'isActiveSolverFFmpeg',
	MEETING_PROVIDER_TEST_CONFIG: 'meetingProviderTestConfig',
	IS_ACTIVE_SOLVER_V2_UPLOAD_SCREEN: 'isActiveSolverV2UploadScreen',
	ENTER_TEST_RESULT: 'enterTestResult',
	IS_ACTIVE_STUDENT_DETAIL_SUPPORT_TAB: 'isActiveStudentDetailSupportTab',
	REVIEWER_EXPERT_ID_LIST: 'reviewerExpertIdList',
	ASSIGN_TO_ME_EXPERT_ID_LIST: 'assignToMeExpertIdList',
	HIDE_EARNINGS_EXPERT_ID_LIST: 'hideEarningsExpertIdList',
	MAX_COACH_ACTIVE_SLOT_DAYS: 'maxCoachActiveSlotDays'
};
